
import React from 'react';
import { BrowserRouter, Link, } from 'react-router-dom';
import animateScrollTo from 'animated-scroll-to';


import s from './SamplePopup.scss';
import PopupForm from '../PopupForm';

export default class SamplePopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };

  }


  render() {
    return (
      <div className="pop-up-container">
        <div className='pop-up'>
          <div onClick={() => this.props.closePopupForm()}
          className='pup-up__close'><span className="af-icon-x"></span></div>
          <div className='pop-up__main row'>

            <div className='pop-up__left col-5'>
              <img className='pop-up__image' src='img/evomer-newest.png' alt='grunt'></img>
            </div>

            <div className='pop-up__right col-7 col-ml-12 '>
              <PopupForm/>

            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SamplePopup/SamplePopup.js